import {
  AddToBagUnavailableIngredient,
  AddToBagUnavailableIngredientsAddAnywayButton,
  AddToBagUnavailableIngredientsBody,
  AddToBagUnavailableIngredientsCancelButton,
  AddToBagUnavailableIngredientsChooseNewButton,
  AddToBagUnavailableIngredientsContainer,
  AddToBagUnavailableIngredientsContent,
  AddToBagUnavailableIngredientsContinueButton,
  AddToBagUnavailableIngredientsFooter,
  AddToBagUnavailableIngredientsHeadline,
  AddToBagUnavailableIngredientsList,
} from './components';

export const AddToBagUnavailableIngredients = {
  Container: AddToBagUnavailableIngredientsContainer,
  Content: AddToBagUnavailableIngredientsContent,
  Headline: AddToBagUnavailableIngredientsHeadline,
  Body: AddToBagUnavailableIngredientsBody,
  List: AddToBagUnavailableIngredientsList,
  Ingredient: AddToBagUnavailableIngredient,
  Footer: AddToBagUnavailableIngredientsFooter,
  AddAnywayButton: AddToBagUnavailableIngredientsAddAnywayButton,
  ChooseNewButton: AddToBagUnavailableIngredientsChooseNewButton,
  CancelButton: AddToBagUnavailableIngredientsCancelButton,
  ContinueButton: AddToBagUnavailableIngredientsContinueButton,
};
